import { AssertionError } from './AssertionError.js'

export function assert(condition: unknown, error?: string | Error): asserts condition {
  if (!condition) {
    if (error) {
      raise(typeof error === 'string' ? `assertion failed: ${error}` : error)
    } else {
      raise('assertion failed')
    }
  }
}

export function raise(error: unknown): never {
  if (typeof error === 'string') {
    throw new AssertionError(error)
  }

  throw error
}
